export interface MagnifyOption {
  zoom?: number;
  height?: number;
  width?: number;
  border?: number;
  borderRadius?: number;
  borderColor?: string;
  backgroundRepeat?: string;
  cursor?: string;
  boxShadow?: string;
}

export const magnyfyOptions: MagnifyOption = {
  zoom: 4,
  height: 200,
  width: 200,
  border: 1,
  borderRadius: 50,
  borderColor: 'white',
  backgroundRepeat: 'no-repeat',
  cursor: 'none'
};
